export const getRemindMeMutationKey = (
  userId?: MaybeRefOrGetter<string | undefined>
) => ['remind-me', userId]
